import React from "react";
import axios from "axios";
import { Avatar } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const photoUrl = (sno) => {
    const base = String(axios.defaults.baseURL || "").replace(/\/=$/,"");
    return `${base}/User/GetNewUserImg?Sno=${encodeURIComponent(sno)}`;
};

export default function EmployeePhoto({serviceNo, name, size = 50}){
    return(
        <Avatar
            src = {serviceNo ? photoUrl(serviceNo) : undefined}
            alt={name || "Employee"}
            sx={{width:size, height:size, border: "2px solid #154c79", bgcolor: "#f1f5f9", color:"#94a3b8"}}
        >
            <PersonIcon/>
        </Avatar>
    );
}